import { addDays } from "date-fns";

const dayNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
] as const;

type DayName = typeof dayNames[number];

export class AikaDate {
  private readonly year: number;
  private readonly month: number;
  private readonly day: number;

  constructor(year: number, month: number, day: number) {
    this.year = year;
    this.month = month;
    this.day = day;
  }

  toString() {
    return `${this.year}-${this.month.toString().padStart(2, "0")}-${this.day
      .toString()
      .padStart(2, "0")}`;
  }

  equals(other: AikaDate) {
    if (other == null) return false;
    return this.toString() === other.toString();
  }

  getDay(): DayName {
    return dayNames[this.asLocalDate().getDay()];
  }

  asLocalDate() {
    return new Date(this.year, this.month - 1, this.day);
  }

  isToday() {
    return this.equals(AikaDate.today());
  }

  addDays(count: number): AikaDate {
    return AikaDate.fromDate(addDays(this.asLocalDate(), count));
  }

  static fromDate(date: Date) {
    return new AikaDate(
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate()
    );
  }

  static fromDateString(dateStr: string) {
    const [year, month, day] = dateStr.split("-").map((x) => parseInt(x, 10));
    console.log(year, month, day);
    return new AikaDate(year, month, day);
  }

  static today() {
    return this.fromDate(new Date());
  }
}
